import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import './CreativeSubformFields.scss';

const StyledInput = withStyles({
  root: {
    marginBottom: '30px'
  }
})(TextField);

export const CreativeSubformFields = props => {
  const [showClickOverride, setShowClickOverride] = useState(!!props.mediaUrlProps.value);
  useEffect(() => {
    if (showClickOverride) {
      return;
    }
    const event = {
      target: {
        name: 'mediaUrl',
        value: ''
      }
    };
    props.mediaUrlProps.onChange(event);
  }, [showClickOverride])

  return (
    <Fragment>
      <label htmlFor="name" className="enhanced-ad_label">
        {props.nameLabel}
      </label>
      <StyledInput {...props.nameProps} id="name" />
      <label className="clickable mb3">
        <input
          type="checkbox"
          className="mr1"
          data-testid="show-click-override"
          checked={showClickOverride}
          onChange={() => {
            setShowClickOverride(!showClickOverride);
          }}
        />
        Apply a manual click override to this ad
      </label>
      {showClickOverride && (
        <StyledInput
          {...props.mediaUrlProps}
          label="DCM Click URL"
          inputProps={{ 'data-testid': 'media-url' }}
          className="enhanced-ad_form-input"
        />
      )}
      <StyledInput
        {...props.headlineProps}
        label="Headline"
        className="enhanced-ad_form-input"
        id="enhanced-ad-headline"
      />
      <label
        htmlFor="advertiser"
        className="enhanced-ad_label enhanced-ad_label--inline"
      >
        Ad By
      </label>
      <StyledInput
        {...props.advertiserProps}
        id="advertiser"
        className="enhanced-ad_form-input"
      />
      <StyledInput
        {...props.descriptionProps}
        label="Description"
        multiline
        rows="2"
        className="enhanced-ad_form-input"
        id="enhanced-ad-description"
      />
    </Fragment>
  );
};

const creativeInputProps = PropTypes.shape({
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string
});

CreativeSubformFields.propTypes = {
  headlineProps: creativeInputProps.isRequired,
  nameProps: creativeInputProps.isRequired,
  advertiserProps: creativeInputProps.isRequired,
  descriptionProps: creativeInputProps.isRequired,
  mediaUrlProps: creativeInputProps.isRequired,
  nameLabel: PropTypes.string.isRequired
};
